import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const FilterButtonWrapper = styled(Box)({
  display: "flex",
  gap: "8px",
})

export const WorkListSectionWrapper = styled(Box)({
  paddingTop: "16px",
  paddingBottom: "32px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
})

export const WorkListTitle = styled(Typography)({
  color: "var(--grey-grey-06)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
})

export const InvoicesContentWrapper = styled(Box)({
  backgroundColor: "var(--background-off-white)",
  paddingLeft: "32px",
  paddingRight: "32px",
  flex: "1",
  display: "flex",
  flexDirection: "column",
  minHeight: '400px'
})

export const PageWrapper = styled(Box)({
  height: "100%",
  display: "flex",
  flexDirection: "column",
})
